// extracted by mini-css-extract-plugin
export default {"container":"Alert_container__wBxzS","title":"Alert_title__2xoxO","text":"Alert_text__5OOVh","button":"Alert_button__V4KUP","cancelButton":"Alert_cancelButton__7zHLc"};